import Select from '../Select/Select';

export const PERIODS = [
  {
    label: '12 (1 Ð³Ð¾Ð´)',
    value: '12',
  },
  {
    label: '24 (2 Ð³Ð¾Ð´Ð°)',
    value: '24',
  },
  {
    label: '36 (3 Ð³Ð¾Ð´Ð°)',
    value: '36',
  },
  {
    label: '48 (4 Ð³Ð¾Ð´Ð°)',
    value: '48',
  },
  {
    label: '60 (5 Ð»ÐµÑ)',
    value: '60',
  },
  {
    label: '72 (6 Ð»ÐµÑ)',
    value: '72',
  },
  {
    label: '84 (7 Ð»ÐµÑ)',
    value: '84',
  },
];

const SelectCreditPeriod = ({
  handleSetSelect,
  handleSetState,
  dependantValue,
  dependencyAccessor,
  style,
  hide,
  ...props
}) => {
  if (dependencyAccessor && dependencyAccessor(dependantValue) !== 6 && dependencyAccessor(dependantValue) !== 7) return null;
  if (hide && hide()) return null;

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={PERIODS}
      placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'}
      style={style}
      {...props}
    />
  );
};

export default SelectCreditPeriod;
